import style from './Error404.module.css';

function Error404() {
  return (
    <div className={style.error404Component}>
      Error 404 <br/> Not Found
    </div>
  )
}

export default Error404;